import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { ContactFragmentOnContactFeedFragmentDoc } from '../../../crm/contacts/__generated__/contact-fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoryTimelineQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type StoryTimelineQuery = { __typename?: 'RootQueryType', storyTimeline?: { __typename?: 'StoryTimeline', id: string, url?: string | null, email?: string | null, isRead?: boolean | null, isSpam?: boolean | null, isArchived?: boolean | null, archivedAt?: any | null, markedAsSpamAt?: any | null, lastEventAt?: any | null, insertedAt?: any | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null, story: { __typename?: 'Initiation', id: string, sid: string, title: string }, responses?: Array<{ __typename?: 'StoryResponse', id: string, type: Types.StoryResponseType, endScreenId?: any | null, answerType?: Types.StoryResponseAnswerType | null, pageChoiceText?: string | null, pageQuestionText?: string | null, pageTitle?: string | null, pageNumber?: number | null, questionTitle?: string | null, stringValue?: string | null, value?: number | null, timestamp?: any | null, product?: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, featuredImage?: { __typename?: 'ProductImage', id: string, src?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } | null, videoUpload?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null } | null> | null } | null };


export const StoryTimelineDocument = gql`
    query storyTimeline($id: ID!) {
  storyTimeline(id: $id) {
    id
    url
    email
    isRead
    isSpam
    isArchived
    archivedAt
    markedAsSpamAt
    lastEventAt
    insertedAt
    contact {
      ...ContactFragmentOnContactFeed
    }
    story {
      id
      sid
      title
    }
    responses {
      id
      type
      endScreenId
      answerType
      pageChoiceText
      pageQuestionText
      pageTitle
      pageNumber
      questionTitle
      stringValue
      value
      timestamp
      product {
        id
        currencyCode
        onlineStoreUrl
        sourceType
        sourceId
        title
        featuredImage {
          id
          src
        }
        variants {
          id
          originalPrice
          price
        }
      }
      videoUpload {
        id
        rawUrl
        transcodedUrl
        previewUrl
        streamUrl
        gifUrl
        contact {
          ...ContactFragmentOnContactFeed
        }
      }
    }
  }
}
    ${ContactFragmentOnContactFeedFragmentDoc}`;

/**
 * __useStoryTimelineQuery__
 *
 * To run a query within a React component, call `useStoryTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryTimelineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStoryTimelineQuery(baseOptions: Apollo.QueryHookOptions<StoryTimelineQuery, StoryTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoryTimelineQuery, StoryTimelineQueryVariables>(StoryTimelineDocument, options);
      }
export function useStoryTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoryTimelineQuery, StoryTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoryTimelineQuery, StoryTimelineQueryVariables>(StoryTimelineDocument, options);
        }
export type StoryTimelineQueryHookResult = ReturnType<typeof useStoryTimelineQuery>;
export type StoryTimelineLazyQueryHookResult = ReturnType<typeof useStoryTimelineLazyQuery>;
export type StoryTimelineQueryResult = Apollo.QueryResult<StoryTimelineQuery, StoryTimelineQueryVariables>;
export function refetchStoryTimelineQuery(variables: StoryTimelineQueryVariables) {
      return { query: StoryTimelineDocument, variables: variables }
    }